import React from 'react'
import Layout from '../../Layout/Layout'

import { Link } from "react-router-dom";

import iff1 from '../../images/iff1.PNG'

import iff2 from '../../images/iff2.PNG'



const IFF_annual_gathering = () => {
  return (
    <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>IIF 8th Annual Gathering</h2></div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>
                    The Impact Investors Foundation (IIF) Annual Gathering, also known as the
                    8th Annual Convening on Impact Investing (ACII), was a critical platform
                    for Moolu Venture Lab to reinforce its strategic partnership with the
                    Foundation. IIF is a leading national institution focused on driving 
                    impact investment and establishing evidence-based entrepreneurship 
                    policy in Nigeria. This collaboration underscores Moolu Venture Lab’s
                    commitment to building a thriving and inclusive impact investment ecosystem.
</p>

                <p className='light'>The event, which was scheduled to hold from Wednesday,
                     November 5th to Thursday, November 6th, 2025, at the Civic Centre in
                      Lagos, is Nigeria's foremost gathering for thought leadership and
                       dialogue in the sector. Moolu Venture Lab, represented by its CEO,
                        Prince Ogbonna, was invited to join a panel to discuss the convening's
                         theme: "Strengthening and Scaling the Nigerian Impact Economy." The
                          goal of this dialogue was to identify the critical steps needed to
                           position Nigeria as a thriving impact economy.</p>
               </div>

                <div className='uk-width-1-2@s'>
                 <img src={iff1} />
               </div>
            </div>







             <div className='uk-grid uk-margin-large-top'>
               <div className='uk-width-1-2@s'>
                   <img src={iff2} />
               </div>

                <div className='uk-width-1-2@s'>
                          <p className='light'>
                    Moolu Venture Lab's active participation in this panel was 
                    crucial for sharing expertise and shaping the narrative around
                     the future of capital deployment for inclusive growth. By
                      engaging with a diverse community of policymakers, investors,
                       entrepreneurs, and development institutions, Moolu Venture Lab
                        contributed to local strategies designed to unlock capital 
                        for sustainable development. 

                <p className='light'>This effort helps the Nigerian
                         economy convert its research and innovation into tangible 
                         benefits such as job creation and improved public health.
</p></p>
               </div>
            </div>
        </div>
        </Layout>
  )
}

export default IFF_annual_gathering